import { Box, Divider, SxProps } from '@mui/material';
import { flexCenter } from '../../../commonUI/cssClasses';

interface Props {
  sx?: SxProps;
}

const CustomTitleDivider: React.FC<Props> = ({ sx }) => {
  return (
    <Box sx={{ width: '100%', height: '100%', ...flexCenter }}>
      <Divider
        sx={{
          width: '90%',
          bgcolor: (theme) => theme.colors.darkTheme.grey.muted,
          mt: '0.5rem',
          ...sx,
        }}
      />
    </Box>
  );
};

export default CustomTitleDivider;
